export default __webpack_public_path__ + "static/media/fillthegaps.b19bc9b8.webp";